import { render, staticRenderFns } from "./ForcableAmountValue.vue?vue&type=template&id=e05cd21a&scoped=true"
import script from "./ForcableAmountValue.vue?vue&type=script&lang=ts"
export * from "./ForcableAmountValue.vue?vue&type=script&lang=ts"
import style0 from "./ForcableAmountValue.vue?vue&type=style&index=0&id=e05cd21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05cd21a",
  null
  
)

export default component.exports